package com.arenaproplay.admin.ui.components.admin

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.BoxScope
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.styleModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.I

/**
 * Night Arena page scene — the fixed dark backdrop behind every admin page:
 * three blurred glowing blobs (blue / mint / yellow), a 58px grid with a
 * radial fade mask and a subtle fractal-noise film. CSS classes are defined
 * in AppTheme (`.na-scene`, `.na-grid`, `.na-noise`).
 *
 * Wrap page/layout content with it; content is rendered above the scene
 * (z-index 2).
 */
@Composable
fun PageScene(
    modifier: Modifier = Modifier,
    content: @Composable BoxScope.() -> Unit
) {
    Box(
        modifier
            .fillMaxSize()
            .styleModifier {
                property("position", "relative")
                property("background", "#05080F")
            }
    ) {
        Div(attrs = { classes("na-scene") }) {
            I(attrs = {}) {}
            I(attrs = {}) {}
            I(attrs = {}) {}
            Div(attrs = { classes("na-grid") }) {}
        }
        Div(attrs = { classes("na-noise") }) {}
        Box(
            Modifier
                .fillMaxSize()
                .styleModifier {
                    property("position", "relative")
                    property("z-index", "2")
                }
        ) {
            content()
        }
    }
}
